import { lock, unlock } from 'tua-body-scroll-lock';

export const showOverlay = (element: Element | null, onClick: () => void): void => {
  const overlay = document.getElementById('overlay');

  if (!overlay || !element) {
    return;
  }

  const layers = parseInt(overlay.dataset.layers ?? '0', 10) || 0;
  overlay.dataset.layers = `${layers + 1}`;
  overlay.addEventListener('click', onClick);
  lock(element as HTMLElement);

  if (layers === 0) {
    overlay.classList.add('active');
  }
};

export const closeOverlay = (element: Element | null, onClick: () => void): void => {
  const overlay = document.getElementById('overlay');

  if (!overlay || !element) {
    return;
  }

  const layers = parseInt(overlay.dataset.layers ?? '0', 10) || 0;
  overlay.dataset.layers = `${Math.max(layers - 1, 0)}`;
  overlay.removeEventListener('click', onClick);
  unlock(element as HTMLElement);

  if (layers === 1) {
    overlay.classList.remove('active');
  }
};
